import { SearchConditionBase } from '@/common/api/search'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { ArticleProposalListItem } from '@/common/model/media/article'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import ArticleListRow from '@/components/container/modules/media/article/table/ArticleListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      <TableHeadItem float={float} {...rectProps(0)}></TableHeadItem>
      <TableHeadItem float={float} {...rectProps(1)}>
        <Text size={12} color={TextColor.SECONDARY}>
          記事タイトル
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(2)}>
        <Text size={12} color={TextColor.SECONDARY}>
          記事ID
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(3)}>
        <Text size={12} color={TextColor.SECONDARY}>
          作成種別
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(4)}>
        <Text size={12} color={TextColor.SECONDARY}>
          記事ステータス
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(5)}>
        <Text size={12} color={TextColor.SECONDARY}>
          更新日時
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(6)}>
        <Text size={12} color={TextColor.SECONDARY}>
          操作
        </Text>
      </TableHeadItem>
    </>
  )
}

const ARTICLE_TABLE_COLUMN_LENGTH = 7

interface Props {
  items: ArticleProposalListItem[]
  condition: SearchConditionBase
  onUpdatePage(page: number): void
  total: number
  onChanged(): void
}

// 記事一覧のテーブル（記事案単位。行を展開すると配下バージョンを表示）
const ArticleListTable = ({ items, condition, onUpdatePage, total, onChanged }: Props) => {
  const listFollowProps = useListScrollFollow(ARTICLE_TABLE_COLUMN_LENGTH)
  const { header } = listFollowProps

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...header} />}
      tableFloatHead={<Thead {...header} float />}
      body={
        <>
          {items.map((item) => (
            <ArticleListRow key={item.article_proposal_id} item={item} onChanged={onChanged} />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default ArticleListTable
